class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    // フォーカスが外れたら onFocusOut() が呼ばれる
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      // フォーカスが要素内に残っていなければ--(今フォーカスが当たっている要素が、このコンポーネントの中に含まれていない（外に出てしまった）)-- close() で閉じる
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);


// ───────────────────────────
// 追加：列クラスの付け替え関数（8以下=1列, 9以上=2列）
// ───────────────────────────
function applyColumnClasses(ul) {
  if (!ul) return;
  // bece.css の block 強制を打ち消すため grid を強制
  ul.classList.add('menu-grid');

  // カウント対象は直下の li
  const count = ul.querySelectorAll(':scope > li').length;

  ul.classList.remove('cols-1', 'cols-2');
  if (count <= 8) {
    ul.classList.add('cols-1');
  } else {
    ul.classList.add('cols-2');
  }
}




// 二階層目 → 三階層目
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.header__submenu--level-2 > li > details').forEach(detailsEl => {
    detailsEl.addEventListener('toggle', () => {
      if (!detailsEl.hasAttribute('open')) return;

      // 「二階層目 → 三階層目」排他制御用リスナー　他に開いている三階層目メニューがあれば閉じておく。
      const container = detailsEl.closest('.header__submenu--level-2');
      container.querySelectorAll('details[open]').forEach(d => {
        if (d !== detailsEl) {
          d.removeAttribute('open');
          d.querySelector('summary').setAttribute('aria-expanded', false);
        }
      });

      
    });
  });
});
  
// ───────────────────────────
// 追加：二階層（子UL）に列数を適用
// メインの header-menu(details) が開いた時に level-2 UL に適用
// ───────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('header-menu > details').forEach(topDetails => {
    topDetails.addEventListener('toggle', () => {
      if (!topDetails.open) return;
      const submenu2 = topDetails.querySelector('.header__submenu--level-2');
      applyColumnClasses(submenu2);
    });
  });
});



// ───────────────────────────
// Hoverで開閉（デスクトップのみ）: 子→孫の移動で閉じないように修正
// ───────────────────────────
(function () {
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!canHover) return;

  const OPEN_DELAY =  80;
  const CLOSE_DELAY = 80;

  function openDetails($details) {
    if ($details.open) return;
    $details.setAttribute('open', '');
    const sum = $details.querySelector('summary');
    if (sum) sum.setAttribute('aria-expanded', 'true');
  }
  function closeDetails($details) {
    if (!$details.open) return;
    $details.removeAttribute('open');
    const sum = $details.querySelector('summary');
    if (sum) sum.setAttribute('aria-expanded', 'false');
  }
  function closeSiblings($details) {
    const parent = $details.parentElement?.parentElement;
    if (!parent) return;
    parent.querySelectorAll(':scope > li > details[open]').forEach(d => {
      if (d !== $details) closeDetails(d);
    });
  }

  // 「トップ」と「第2階層」の details を対象
  const allDetails = document.querySelectorAll(
    'header-menu > details,' +
    '.header__submenu--level-2 > li > details'
  );

  allDetails.forEach($details => {
    let openTimer = null;
    let closeTimer = null;

    const onEnter = () => {
      clearTimeout(closeTimer);
      openTimer = setTimeout(() => {
        closeSiblings($details);
        openDetails($details);

        // 2階層ULの列数を可変運用している場合のみ
        const submenu2 = $details.querySelector('.header__submenu--level-2.menu-grid');
        if (submenu2 && typeof applyColumnClasses === 'function') {
          applyColumnClasses(submenu2);
        }
      }, OPEN_DELAY);
    };

    // ★ relatedTarget が自分の子孫なら「外に出ていない」とみなして閉じない
    const onLeave = (e) => {
      if (e && e.relatedTarget && $details.contains(e.relatedTarget)) return;

      clearTimeout(openTimer);
      closeTimer = setTimeout(() => {
        // フォーカスが内側なら閉じない（キーボード配慮）
        if ($details.contains(document.activeElement)) return;

        // まだホバーが戻ってきていれば閉じない（保険）
        const hoveredInside =
          $details.matches(':hover') ||
          !!$details.querySelector('.header__submenu:hover') ||
          !!$details.querySelector('.header__submenu--level-3:hover');
        if (hoveredInside) return;

        closeDetails($details);
      }, CLOSE_DELAY);
    };

    // ここを mouseenter/mouseleave ではなく pointer 系に
    $details.addEventListener('pointerenter', onEnter);
    $details.addEventListener('pointerleave', onLeave);

    // サブメニュー側にも同じハンドラを付与（孫→子の往復でもタイマーを適切に制御）
    ['.header__submenu', '.header__submenu--level-3'].forEach(sel => {
      const el = $details.querySelector(sel);
      if (!el) return;
      el.addEventListener('pointerenter', onEnter);
      el.addEventListener('pointerleave', onLeave);
    });
  });

  //  以前の「header から mouseleave したら全部閉じる」は外側にフライアウトしていると誤爆しがち
  //  代わりに「メニュー外クリックで閉じる」に変更（必要な場合のみ）
  document.addEventListener('pointerdown', (e) => {
    const withinMenu = e.target.closest('header-menu, .header__submenu--level-2');
    if (withinMenu) return;
    document
      .querySelectorAll('header-menu > details[open], .header__submenu--level-2 > li > details[open]')
      .forEach(d => {
        if (!d.contains(document.activeElement)) closeDetails(d);
      });
  });
})();


